var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmitDetailsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.416,
    height: 64.416,
    rx: 32.208,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.339 32.6814L33.7295 38.291L35.6697 40.2312L41.2792 34.6216L39.339 32.6814Z",
    fill: "#F0C330"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8179 27.9348C30.2325 27.9348 32.208 29.9104 32.208 32.3251V33.2037H23.4277V32.3251C23.4277 29.9104 25.4033 27.9348 27.8179 27.9348Z",
    fill: "#DA867D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8179 27.937C29.1969 27.937 30.3148 26.8191 30.3148 25.4401C30.3148 24.061 29.1969 22.9431 27.8179 22.9431C26.4389 22.9431 25.321 24.061 25.321 25.4401C25.321 26.8191 26.4389 27.937 27.8179 27.937Z",
    fill: "#DA867D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4392 35.6939V45.708H20.6836V18.708H34.9516L40.4392 24.1958V31.4957",
    stroke: "#1E247E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9514 18.9822V24.1956H40.1647",
    stroke: "#1E247E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8547 27.7158H37.6961M37.6961 30.4597H34.9523",
    stroke: "#1E247E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4277 35.9473H31.1105M29.4642 38.6912H23.4277",
    stroke: "#1E247E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4106 41.435H32.5264L35.6703 40.2315L43.5045 32.3971C43.8919 32.0091 43.7729 31.2557 43.2395 30.7223C42.7061 30.1888 41.952 30.0692 41.5646 30.4572L33.7304 38.2916L32.5379 41.4059",
    stroke: "#1E247E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitDetailsIcon);
export default __webpack_public_path__ + "static/media/SubmitDetailsIcon.ae96d10a12c0f9d13d2e1a4f22f05871.svg";
export { ForwardRef as ReactComponent };